module.exports = __webpack_public_path__ + "dc9104f0e5595258ab9c14b4db30e25e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cogoland/Cogo_Logo.png
// module id = 1397
// module chunks = 0